export default "__VITE_ASSET__DzOvLHPH__"